import React, { useState } from 'react'
import { CaretLeftIcon, CaretRightIcon } from '@phosphor-icons/react'
import { ScoopDrawer } from '../../ui'
import { ScoopTab } from '../../ui'
import { ScoopColumn } from '../../ui'
import { leftDrawerTabs, rightDrawerTabs } from './consts'
import styles from './ExplorerV2.module.scss'

/**
 * Layout component for Explorer.
 * Manages drawer state and tab navigation.
 * Uses render props pattern for drawer content.
 *
 * @param {Object} props
 * @param {Function} props.leftContent - Render function for left drawer: (activeTab) => ReactNode
 * @param {Function} props.rightContent - Render function for right drawer: (activeTab) => ReactNode
 * @param {React.ReactNode} props.centerContent - Content for the center area
 */
export const ExplorerLayout = ({ leftContent, rightContent, centerContent }) => {
    const [leftTab, setLeftTab] = useState(leftDrawerTabs[0].key)
    const [rightTab, setRightTab] = useState(rightDrawerTabs[0].key)
    const [leftOpen, setLeftOpen] = useState(true)
    const [rightOpen, setRightOpen] = useState(true)

    return (
        <div className={styles.explorerLayout}>
            {/* Left Drawer */}
            <ScoopDrawer
                open={leftOpen}
                anchor="left"
                variant="persistent"
                width={300}
                onClose={() => setLeftOpen(false)}
            >
                <ScoopColumn className={styles.drawerContent}>
                    <ScoopTab
                        tabs={leftDrawerTabs}
                        value={leftTab}
                        onChange={(e, value) => setLeftTab(value)}
                    />
                    <div className={styles.tabContent}>{leftContent(leftTab)}</div>
                </ScoopColumn>
            </ScoopDrawer>

            {/* Center Content */}
            <div
                className={[
                    styles.centerContent,
                    leftOpen && styles.leftDrawerOpen,
                    rightOpen && styles.rightDrawerOpen,
                ]
                    .filter(Boolean)
                    .join(' ')}
            >
                {/* Left drawer toggle */}
                <button
                    className={`${styles.drawerToggle} ${styles.leftToggle}`}
                    onClick={() => setLeftOpen(!leftOpen)}
                    aria-label={leftOpen ? 'Close left panel' : 'Open left panel'}
                >
                    {leftOpen ? <CaretLeftIcon size={16} /> : <CaretRightIcon size={16} />}
                </button>

                {centerContent}

                {/* Right drawer toggle */}
                <button
                    className={`${styles.drawerToggle} ${styles.rightToggle}`}
                    onClick={() => setRightOpen(!rightOpen)}
                    aria-label={rightOpen ? 'Close right panel' : 'Open right panel'}
                >
                    {rightOpen ? <CaretRightIcon size={16} /> : <CaretLeftIcon size={16} />}
                </button>
            </div>

            {/* Right Drawer */}
            <ScoopDrawer
                open={rightOpen}
                anchor="right"
                variant="persistent"
                width={300}
                onClose={() => setRightOpen(false)}
            >
                <ScoopColumn className={styles.drawerContent}>
                    <ScoopTab
                        tabs={rightDrawerTabs}
                        value={rightTab}
                        onChange={(e, value) => setRightTab(value)}
                    />
                    <div className={styles.tabContent}>{rightContent(rightTab)}</div>
                </ScoopColumn>
            </ScoopDrawer>
        </div>
    )
}
